// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kf-0";
export var fileCarousel = "_kf-2";
export var removeFileButton = "_kf-1";